var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "main-body"
  }, [_c('Modal', {
    attrs: {
      "title": "取消销售订单"
    },
    on: {
      "on-ok": function ($event) {
        return _vm.cancelOperate();
      },
      "on-cancel": function ($event) {
        _vm.cancelSalesOrderModal = false;
      }
    },
    model: {
      value: _vm.cancelSalesOrderModal,
      callback: function ($$v) {
        _vm.cancelSalesOrderModal = $$v;
      },
      expression: "cancelSalesOrderModal"
    }
  }, [_c('Form', {
    ref: "formItem",
    attrs: {
      "model": _vm.formItem,
      "label-width": 80
    },
    nativeOn: {
      "submit": function ($event) {
        $event.preventDefault();
      }
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "取消理由"
    }
  }, [_c('Input', {
    attrs: {
      "type": "text",
      "placeholder": "请输入取消销售订单的理由"
    },
    model: {
      value: _vm.formItem.canceledReason,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "canceledReason", $$v);
      },
      expression: "formItem.canceledReason"
    }
  })], 1)], 1)], 1), _c('div', {
    staticClass: "left-panel"
  }, [_c('h2', [_vm._v("工厂")]), _c('Select', {
    on: {
      "on-change": _vm.changeFactory
    },
    model: {
      value: _vm.selectedFactoryId,
      callback: function ($$v) {
        _vm.selectedFactoryId = $$v;
      },
      expression: "selectedFactoryId"
    }
  }, _vm._l(_vm.factoryList, function (option, index) {
    return _c('Option', {
      key: index,
      attrs: {
        "value": option._id
      }
    }, [_vm._v(_vm._s(option.name))]);
  }), 1), _c('div', {
    staticClass: "select-wrap"
  }, [_c('h2', [_vm._v("抵达时间")]), _c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('Icon', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "type": "md-arrow-dropleft",
      "size": "24"
    },
    on: {
      "click": function ($event) {
        return _vm.changeplanArrivedAt(null, null, '-');
      }
    }
  }), _c('DatePicker', {
    attrs: {
      "type": "date",
      "open": _vm.dateCalOpen,
      "options": _vm.planArrivedAtOptions
    },
    on: {
      "on-change": _vm.changeplanArrivedAt,
      "on-clickoutside": function ($event) {
        _vm.dateCalOpen = false;
      }
    }
  }, [_c('h1', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function ($event) {
        _vm.dateCalOpen = !_vm.dateCalOpen;
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.planArrivedAtDisplay) + " ")])]), _c('Icon', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "type": "md-arrow-dropright",
      "size": "24"
    },
    on: {
      "click": function ($event) {
        return _vm.changeplanArrivedAt(null, null, '+');
      }
    }
  })], 1)])], 1), _c('div', {
    staticClass: "right-panel"
  }, [_c('div', {
    staticClass: "select-wrap"
  }), _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "section-header-wrapper"
  }, [_c('h3', [_vm._v(" " + _vm._s(_vm.getFactoryById(_vm.selectedFactoryId) ? _vm.getFactoryById(_vm.selectedFactoryId).name : null) + " ")])]), _c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('span', [_vm._v("共" + _vm._s(_vm.totalRows) + "条")]), _c('Page', {
    staticStyle: {
      "margin-right": "24px"
    },
    attrs: {
      "total": _vm.totalRows,
      "page-size": 15,
      "show-total": "",
      "simple": ""
    },
    on: {
      "on-change": _vm.changePage
    }
  })], 1)]), _c('Table', {
    attrs: {
      "columns": _vm.columns,
      "data": _vm.tableData,
      "size": "small",
      "draggable": true,
      "loading": _vm.loadingTableData
    },
    scopedSlots: _vm._u([{
      key: "productOperate",
      fn: function (_ref) {
        var row = _ref.row;
        return [!row.startedAt ? _c('Dropdown', {
          attrs: {
            "transfer": ""
          },
          on: {
            "on-click": function ($event) {
              return _vm.changeProductOperate($event, row);
            }
          }
        }, [_c('a', {
          attrs: {
            "href": "javascript:void(0)"
          }
        }, [_vm._v(" 操作 "), _c('Icon', {
          attrs: {
            "type": "ios-arrow-down"
          }
        })], 1), _c('DropdownMenu', {
          attrs: {
            "slot": "list"
          },
          slot: "list"
        }, [_c('DropdownItem', {
          staticClass: "operate-item",
          attrs: {
            "name": "edit",
            "disabled": row.startedAt ? true : false
          }
        }, [_vm._v("修改订单")]), _c('DropdownItem', {
          staticClass: "operate-item",
          attrs: {
            "name": "cancel",
            "disabled": row.startedAt ? true : false
          }
        }, [_vm._v("取消订单")])], 1)], 1) : _vm._e()];
      }
    }])
  })], 1), _c('PrintOrderDrawer', {
    ref: "PrintOrderDrawer",
    attrs: {
      "selectedRecipeDetail": _vm.selectedRecipeDetail
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }